<top-banner variant="small"></top-banner>

<div class="main-content">
  <div class="row animated fadeIn">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body mb-2">
          <card-section-header
              title="All Sites Schedule"
              icon="fas fa-list">
          </card-section-header>

          <scheduler-filters (filtersChanged)="onFiltersChanged($event)"></scheduler-filters>

          <div *ngIf="!response" style="width: 50px; margin: 0 auto">
            <p-progressSpinner [style]="{ width: '50px', height: '50px' }" [strokeWidth]="4"></p-progressSpinner>
          </div>

          <div *ngIf="noResultsMessage">
            <p>No Bazefield enabled sites detected</p>
          </div>
          <ng-container *ngIf="response">
            <div *ngFor="let site of response.sites">
              <a [routerLink]="['/', routeRole, 'sites', site.id, 'schedule']">
                {{ site.name }}
              </a>

              <scheduler
                  [hoursPerColumn]="hoursPerColumn"
                  [siteId]="site.id"
                  [assetsAndSchedules]="site.assets"
                  [start]="startTime"
                  [end]="endTime"
                  (gridClick)="onGridClick($event)"
                  (bookingClick)="onBookingClick($event)"
              ></scheduler>
              <hr>
              <br>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

